import { render, staticRenderFns } from "./NavigationV2.vue?vue&type=template&id=1b951145&"
import script from "./NavigationV2.vue?vue&type=script&lang=js&"
export * from "./NavigationV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports